import { Component, Input, ViewChild, OnInit, inject, DestroyRef } from '@angular/core';
import { DeployInstanceFormComponent } from 'src/app/main/service/deploy-instance-form/deploy-instance-form.component';
import { Constants } from 'src/app/models/constants';
import { Deployment } from 'src/app/models/deploy/deployment';
import { Solution } from 'src/app/models/service/solution';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { translate } from '@jsverse/transloco';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { PathToLiveEnvironment } from 'src/app/models/blueprints/path-to-live-environment';
import moment from 'moment';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import {ISBModes} from 'src/app/models/blueprints/blueprint';


@Component({
    selector: 'app-deploy-instance',
    templateUrl: './deploy-instance.component.html',
    styleUrls: ['./deploy-instance.component.scss'],
    standalone: false
})
export class DeployInstanceComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  @ViewChild('deployInstanceForm', { static: false }) public deployInstanceForm: DeployInstanceFormComponent;

  @Input() title: string;
  @Input() subtitle: string;
  @Input() deployment: Deployment;
  @Input() service: Solution;
  @Input() tenantDetails: any;
  @Input() blueprintsVersionList: any;
  @Input() buildNumber: any;
  @Input() blueprint: any;
  @Input() currentBuildNumber: any;
  @Input() bluerprintById: any;
  @Input() instanceBlueprint: any;
  @Input() checkDeploymentClass: any;
  @Input() allInstances: any;
  @Input() confirmationMsg: any;
  @Input() nonPtlFlow: boolean;
  @Input() selectedISBType: string
  @Input() pathToLiveFlow: boolean;

  Constants = Constants;
  changedBuildVersion: Solution;
  targetSolutionVersionId: Solution;
  checkValidation: any;
  currentVersion: any;
  DeploymentClass: DeploymentClass;
  PathToLiveEnvironment: PathToLiveEnvironment;
  submitDisableData: any;
  isDuplicateInstance = false;

  constructor(
    private solutionService: SolutionsService,
     public sidenavService: SidenavService, private dialog: MatDialog) {
    
   }

  ngOnInit(): void {

    let blueprintInstance;
    this.instanceBlueprint = this.instanceBlueprint?.data? this.instanceBlueprint?.data : this.instanceBlueprint;
    const  D = this.instanceBlueprint?.filter(b => b.deploymentClass === DeploymentClass.D);
      if (D?.length !== 0) {
        blueprintInstance = D.slice(-1);
      }


    const C = this.instanceBlueprint?.filter(b => b.deploymentClass === DeploymentClass.C);
      if (C.length === 0) {
        blueprintInstance = D.slice(-1);
      } else {
        blueprintInstance = C.slice(-1);
      }

    const B = this.instanceBlueprint?.filter(b => b.deploymentClass === DeploymentClass.B);
      if (B.length === 0 && C.length === 0) {
        blueprintInstance = D.slice(-1);
      } else if (B.length === 0 && C.length !== 0) {
        blueprintInstance = C.slice(-1);
      } else {
        blueprintInstance = B.slice(0);
      }

      const solutionId = blueprintInstance[0]?.solutionId;
      const solutionVersionId = blueprintInstance[0]?.solutionVersionId;
      this.getSolutionVersion(solutionId, solutionVersionId);
  }

  getSolutionVersion(solutionId, solutionVersionId): void {
    if (solutionId && solutionVersionId) {
      this.solutionService.getSolutionVersion(solutionId, solutionVersionId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (solutionVersion) => {
        this.currentVersion = solutionVersion?.releaseVersion;
      });
    }
  }

  buildVersion(version?: any): void {
    this.changedBuildVersion = version;
  }

  submitDisable(value?: any): void {
    this.submitDisableData = value;
  }

  verifyDuplicate(instance?: any): void {
    this.isDuplicateInstance = instance;
  }

  /**
   * Confirmation an build version
   *
   * @param build version - the build version confirmation
   */

  confirmVersionBox(newDeployment, changedVersion): void {
    let message;
    if(this.confirmationMsg) {
      if (this.selectedISBType === ISBModes.EXTERNAL) {
        message = translate('VERSIONS.MIGRATIONMSG');
      }
    }
      if (this.currentVersion !== changedVersion
        && this.instanceBlueprint?.length > 0) {
        message = translate('VERSIONS.SUBTITLE', {
          currentBuildVersion: this.currentVersion,
          changedBuildVersion: changedVersion
        });
      }

      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('VERSIONS.TITLE'),
          message,
          confirmButtonText: translate('DIALOG.CONFIRM')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.sidenavService.closeRightSidenav(newDeployment);
          }
        });

  }

  /**
   * Validates the form and if the validation results successful, the
   * sidenav service is closed and we get the configuration instance object
   */
  createDeployment(): void {
    let solutionVersionId;
    const newDeployment = this.deployInstanceForm.getDeployment();
    newDeployment.contractEndDate = newDeployment.contractEndDate ? moment(newDeployment.contractEndDate).utcOffset("+05:30").format("YYYY-MM-DD") : newDeployment.contractEndDate;
    if(!this.tenantDetails.contractEndDate) {
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.CONTRACT_END_DATE_NA'),
          description: translate('ERROR_DIALOG.TENANT_CONTRACT_END_DATE_NOT_AVAILABLE')
        }
      });
    }
    else if (newDeployment) {
      solutionVersionId = this.buildNumber?.find(v => v.version === newDeployment?.buildNumber);
      delete newDeployment.buildNumber;
      newDeployment.targetSolutionVersionId = solutionVersionId?.id;
      this.confirmVersionBox(newDeployment, solutionVersionId?.releaseVersion);
    }
  }
}
